import DialogTpl from './Dialog.vue';

let VueDialog = {}
VueDialog.install = function(Vue,options={}){
    const dialogConstructor = Vue.extend(DialogTpl)//创建模板
    dialogConstructor.prototype.callBack
    // 生成一个该之类的实例
    const instance = new dialogConstructor();
    Vue.prototype.$Dialog={};
    Vue.prototype.$Dialog.confirm = (option) =>{
        return new Promise((resolve,reject) => {
            instance.show(option);
            instance.callBack=(action)=>{
                if(!action) reject()
                resolve()
            }
        });
    }

    instance.$mount(document.createElement('div'))
    document.body.appendChild(instance.$el)
}
export default VueDialog